import { Routes, Route } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import { LanguageProvider } from './contexts/LanguageContext'
import { CartProvider } from './contexts/CartContext'
import Header from './components/Header'
import Footer from './components/Footer'
import LiveSupport from './components/LiveSupport'
import ScrollToTop from './components/ScrollToTop'
import Home from './pages/Home'
import Services from './pages/Services'
import About from './pages/About'
import Contact from './pages/Contact'
import Shopify from './pages/Shopify'
import Blog from './pages/Blog'
import BlogDetail from './pages/BlogDetail'
import Academy from './pages/Academy'
import References from './pages/References'
import Career from './pages/Career'
import GoogleAds from './pages/services/GoogleAds'
import MetaAds from './pages/services/MetaAds'
import SocialMedia from './pages/services/SocialMedia'
import WebDesign from './pages/services/WebDesign'
import AppDevelopment from './pages/services/AppDevelopment'
import Marketplace from './pages/services/Marketplace'
import SeoGeo from './pages/services/SeoGeo'
import Mentorluk from './pages/services/Mentorluk'
import UgcInfluencer from './pages/services/UgcInfluencer'
import MarketingTools from './pages/MarketingTools'
import Glossary from './pages/Glossary'
import Education from './pages/Education'
import Privacy from './pages/Privacy'
import NotFound from './pages/NotFound'
import Consulting from './pages/Consulting'
import ConsultingDetail from './pages/ConsultingDetail'
import Checkout from './pages/Checkout'
import DeliveryRefund from './pages/DeliveryRefund'
import DistanceSales from './pages/DistanceSales'
import IstanbulDigitalMarketingAgency from './pages/locations/IstanbulDigitalMarketingAgency'
import IstanbulPerformanceMarketingAgency from './pages/locations/IstanbulPerformanceMarketingAgency'
import IstanbulBahcelievlerWebTasarim from './pages/locations/IstanbulBahcelievlerWebTasarim'
import IstanbulBahcelievlerETicaretDanismanligi from './pages/locations/IstanbulBahcelievlerETicaretDanismanligi'
import IstanbulBakirkoyPerformansPazarlama from './pages/locations/IstanbulBakirkoyPerformansPazarlama'
import IstanbulBakirkoyETicaretAjansi from './pages/locations/IstanbulBakirkoyETicaretAjansi'
import IstanbulBahcelievlerShopify from './pages/locations/IstanbulBahcelievlerShopify'
import ConsultingSuccess from './pages/ConsultingSuccess'
import DigitalMarketingGuide from './pages/DigitalMarketingGuide'
import WhatsAppLinkGenerator from './pages/WhatsAppLinkGenerator'
import QRCodeGenerator from './pages/QRCodeGenerator'
import UTMLinkGenerator from './pages/UTMLinkGenerator'
import DesiCalculator from './pages/DesiCalculator'

function App() {
  return (
    <HelmetProvider>
      <LanguageProvider>
        <CartProvider>
          <ScrollToTop />
          <div className="min-h-screen bg-white">
            <Header />
            <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/services/seo-geo" element={<SeoGeo />} />
              <Route path="/services/mentorluk" element={<Mentorluk />} />
              <Route path="/services/ugc-influencer" element={<UgcInfluencer />} />
              <Route path="/services/google-ads" element={<GoogleAds />} />
              <Route path="/services/meta-ads" element={<MetaAds />} />
              <Route path="/services/social-media" element={<SocialMedia />} />
              <Route path="/services/web-design" element={<WebDesign />} />
              <Route path="/services/app-development" element={<AppDevelopment />} />
              <Route path="/services/marketplace" element={<Marketplace />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/shopify" element={<Shopify />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/dijital-pazarlama-rehberi" element={<DigitalMarketingGuide />} />
              <Route path="/blog/:slug" element={<BlogDetail />} />
              <Route path="/academy" element={<Academy />} />
              <Route path="/references" element={<References />} />
              <Route path="/career" element={<Career />} />
              <Route path="/marketing-tools" element={<MarketingTools />} />
              <Route path="/whatsapp-link-generator" element={<WhatsAppLinkGenerator />} />
              <Route path="/qr-code-generator" element={<QRCodeGenerator />} />
              <Route path="/utm-link-generator" element={<UTMLinkGenerator />} />
              <Route path="/desi-calculator" element={<DesiCalculator />} />
              <Route path="/glossary" element={<Glossary />} />
              <Route path="/education" element={<Education />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/delivery-refund" element={<DeliveryRefund />} />
              <Route path="/distance-sales" element={<DistanceSales />} />
              <Route path="/consulting" element={<Consulting />} />
              <Route path="/consulting/:id" element={<ConsultingDetail />} />
              <Route path="/consulting/success" element={<ConsultingSuccess />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/istanbul-dijital-pazarlama-ajansi" element={<IstanbulDigitalMarketingAgency />} />
              <Route path="/istanbul-performans-pazarlama-ajansi" element={<IstanbulPerformanceMarketingAgency />} />
              <Route path="/istanbul-bahcelievler-web-tasarim" element={<IstanbulBahcelievlerWebTasarim />} />
              <Route path="/istanbul-bahcelievler-e-ticaret-danismanligi" element={<IstanbulBahcelievlerETicaretDanismanligi />} />
              <Route path="/istanbul-bakirkoy-performans-pazarlama-ajansi" element={<IstanbulBakirkoyPerformansPazarlama />} />
              <Route path="/istanbul-bakirkoy-e-ticaret-ajansi" element={<IstanbulBakirkoyETicaretAjansi />} />
              <Route path="/istanbul-bahcelievler-shopify-web-tasarimi" element={<IstanbulBahcelievlerShopify />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
        </main>
          <Footer />
          <LiveSupport />
        </div>
        </CartProvider>
      </LanguageProvider>
    </HelmetProvider>
  )
}

export default App

